// extracted by mini-css-extract-plugin
export default {"zoomModal":"X4-z","image":"Y4-z","button":"Z4-z","isOverlayShown":"_4-z"};